import React from 'react';
import { Check, X, Info } from 'lucide-react';
import clsx from 'clsx';
const PaketKarti = ({ pkg, selected, onClick }) => {
    // Remove isSelected derived state since we use passed 'selected' prop for selection logic
    // But we might want 'recommended' style if nothing is selected? 
    // Actually the logic was 'selected || pkg.recommended' before.
    // User wants selection to work. Let's stick to 'selected' prop for active state.

    return (
        <div
            onClick={onClick}
            className={clsx(
                "relative rounded-2xl transition-all duration-300 flex flex-col h-full cursor-pointer group",
                selected
                    ? "border-2 border-orange-500 bg-white dark:bg-bg-secondary shadow-2xl transform scale-[1.03] z-20 ring-4 ring-orange-500/20"
                    : "border border-border-light bg-bg-secondary/30 hover:bg-bg-secondary hover:border-orange-300 hover:shadow-xl z-0 opacity-90 hover:opacity-100"
            )}
        >
            {pkg.recommended && (
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 w-full text-center">
                    <span className={clsx(
                        "text-xs font-bold px-6 py-2 rounded-full uppercase tracking-wider shadow-lg border-2 border-white dark:border-bg-primary transition-all",
                        selected ? "bg-gradient-to-r from-orange-500 to-red-500 text-white" : "bg-bg-tertiary text-text-muted"
                    )}>
                        En Çok Tercih Edilen
                    </span>
                </div>
            )}

            <div className="p-8 flex-1">
                <div className="flex items-center justify-between mb-6">
                    <h3 className={clsx("text-xl font-bold tracking-tight transition-colors", selected ? "text-orange-600" : "text-text-primary group-hover:text-orange-600")}>
                        {pkg.name}
                    </h3>
                    <div className={clsx("p-2 rounded-lg transition-colors", selected ? "bg-orange-100 text-orange-600" : "bg-bg-tertiary text-text-muted group-hover:bg-orange-50 group-hover:text-orange-500")}>
                        <pkg.icon size={24} />
                    </div>
                </div>

                <div className={clsx("mb-8 p-4 rounded-xl border transition-colors", selected ? "bg-orange-50 border-orange-200" : "bg-bg-tertiary/50 border-border-light/50 group-hover:border-orange-100")}>
                    <div className="flex items-baseline">
                        <span className="text-4xl font-black text-text-primary tracking-tight">₺{pkg.price}</span>
                        <div className="ml-2 flex flex-col items-start">
                            <span className="text-text-secondary font-medium text-lg leading-none">/ {pkg.period}</span>
                            <span className="text-xs text-text-muted font-normal mt-0.5">(+ KDV)</span>
                        </div>
                    </div>
                    {pkg.highlightText && (
                        <p className="text-sm text-orange-600 font-bold mt-2 flex items-center gap-1">
                            <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse"></span>
                            {pkg.highlightText}
                        </p>
                    )}
                    <p className="mt-3 text-sm text-text-secondary leading-relaxed border-t border-border-light/50 pt-3">
                        {pkg.description}
                    </p>
                </div>

                {/* Features List */}
                <ul className="space-y-4 mb-8">
                    {pkg.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start">
                            <div className={clsx(
                                "flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mt-0.5 shadow-sm transition-colors duration-300",
                                selected ? "bg-orange-100 text-orange-600" : "bg-gray-100 text-gray-400 group-hover:bg-orange-100 group-hover:text-orange-600"
                            )}>
                                <Check size={14} strokeWidth={3} />
                            </div>
                            <span className={clsx("ml-3 text-sm transition-colors duration-300", selected ? "text-text-primary font-medium" : "text-text-secondary group-hover:text-text-primary")}>
                                {feature}
                            </span>
                        </li>
                    ))}

                    {pkg.upcomingFeatures?.map((feature, idx) => (
                        <li key={`up-${idx}`} className="flex items-start">
                            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-purple-100 dark:bg-purple-900/30 text-purple-600 flex items-center justify-center mt-0.5">
                                <Info size={14} />
                            </div>
                            <div className="ml-3">
                                <span className="text-sm font-medium text-text-primary">{feature}</span>
                                <span className="ml-2 text-[10px] font-bold bg-purple-100 text-purple-700 px-1.5 py-0.5 rounded border border-purple-200 uppercase">Yakında</span>
                            </div>
                        </li>
                    ))}

                    {pkg.notIncluded?.map((feature, idx) => (
                        <li key={idx} className="flex items-center opacity-40 hover:opacity-60 transition-opacity">
                            <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center bg-bg-tertiary">
                                <X size={14} className="text-text-muted" />
                            </div>
                            <span className="ml-3 text-sm text-text-muted line-through">{feature}</span>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="p-8 pt-0 mt-auto">
                <button
                    className={clsx(
                        "w-full py-4 px-6 rounded-xl text-base font-bold transition-all shadow-md active:scale-95 flex items-center justify-center gap-2",
                        pkg.buttonVariant === 'primary'
                            ? "bg-primary text-white hover:bg-primary-dark hover:shadow-primary/30"
                            : pkg.buttonVariant === 'dark'
                                ? "bg-gray-900 text-white hover:bg-black hover:shadow-gray-900/30"
                                : "bg-white text-text-primary border-2 border-border-light hover:border-primary/50 hover:bg-bg-tertiary"
                    )}
                >
                    {pkg.name === 'KURUMSAL' ? 'Satış Ekibiyle Görüş' : 'Paketi Seç'}
                </button>
            </div>
        </div>
    );
};

export default PaketKarti;
